import { render, staticRenderFns } from "./PortalProposta.vue?vue&type=template&id=081bba9c"
import script from "./PortalProposta.vue?vue&type=script&lang=js"
export * from "./PortalProposta.vue?vue&type=script&lang=js"
import style0 from "./PortalProposta.vue?vue&type=style&index=0&id=081bba9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports